import * as React from 'react'
import { useState } from 'react'

import { Box, Button, Hint, useToggle } from '@factorialco/deprecated-design-system'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import DynamicMap from 'modules/locations/components/GoogleMaps/DynamicMap'

import CancelModal from './CancelModal'

interface Props {
  show: boolean
  onClose: () => void
  lat: number
  lng: number
  radius: number
  onMarkerChange: (lat: number | undefined, lng: number | undefined) => void
}

const MapSidePanel = ({ show, onClose, lat, lng, radius, onMarkerChange }: Props) => {
  const [marker, setMarker] = useState<google.maps.Marker>()
  const [cancelModalOpen, toggleCancelModal] = useToggle(false)
  const [showHint, setShowHint] = useToggle(false)

  const onClickConfirm = () => {
    const newLatLng = marker?.getPosition()?.toJSON()
    onMarkerChange(newLatLng?.lat, newLatLng?.lng)
    toggleCancelModal(false)()
    onClose()
  }

  const onClickCancel = () => {
    const markerPostion = marker?.getPosition()?.toJSON()
    const markerPostionChanged = markerPostion?.lat != lat && markerPostion?.lng != lng

    if (!markerPostionChanged) return onClose()

    toggleCancelModal(true)()
  }

  const onModalClickCancel = () => {
    toggleCancelModal(false)()
    onClose()
  }

  return (
    <>
      <Sidepanel
        width="full"
        closeLabel="close"
        onClose={onClose}
        title={i18n.t('settings.locations.map.edit_button')}
        open={show}
        footer={
          <>
            <Button type="secondary" onClick={onClickCancel}>
              {i18n.t('common.cancel')}
            </Button>
            {showHint && (
              <Box>
                <Hint.Popover.Provider steps={1} isHidden={!showHint}>
                  <Hint.Popover
                    step={1}
                    title={i18n.t('settings.locations.dynamic_map.popover.title')}
                    description={''}
                    actionLabel={i18n.t('common.close')}
                    position="top right"
                  >
                    <Button onClick={onClickConfirm}>
                      {i18n.t('settings.locations.map.save_location_button')}
                    </Button>
                  </Hint.Popover>
                </Hint.Popover.Provider>
              </Box>
            )}
          </>
        }
      >
        <DynamicMap
          lat={Number(lat)}
          lng={Number(lng)}
          radius={Number(radius)}
          marker={marker}
          setMarker={setMarker}
          setShowHint={() => {
            setShowHint(true)()
          }}
        />
      </Sidepanel>
      {cancelModalOpen && (
        <CancelModal onClickCancel={onModalClickCancel} onClickConfirm={onClickConfirm} />
      )}
    </>
  )
}

export default MapSidePanel
